var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6" }, [
        _c("label", { attrs: { for: "" } }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$resourceString["contentWizard.Label.DocumentType"]) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-2 justify-content-between align-items-center" },
          [
            _c("div", { staticClass: "input-group" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedOption,
                      expression: "selectedOption"
                    }
                  ],
                  staticClass: "form-control form-control-sm text-capitalize",
                  attrs: {
                    name: "galleryImageType",
                    id: _vm.selectedOption,
                    required: "required"
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedOption = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.handleImageType
                    ]
                  }
                },
                [
                  _c(
                    "option",
                    {
                      attrs: { value: "", disabled: "" },
                      domProps: { selected: true }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$resourceString[
                              "contentWizard.DocumentType.Dropdown.placeholder"
                            ]
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.getDocumentFilters, function(item, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: item } },
                      [
                        _vm._v(
                          "\n              " + _vm._s(item) + "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "pl-3 pt-3" }, [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$resourceString["contentWizard.Label.AddDocument"]) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("document-search", {
          attrs: {
            isDocument: true,
            cols: "sm-12",
            placeholderName:
              _vm.$resourceString[
                "contentWizard.Label.SearchFieldDocument.Placeholder"
              ]
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-end pl-1 pr-2" }),
    _vm._v(" "),
    _vm.getDocumentData
      ? _c(
          "div",
          {
            staticClass: "row mt-2",
            class:
              _vm.getDocumentData.length > 3
                ? "inspiration-gallery-item-container pr-4"
                : ""
          },
          [
            _c(
              "div",
              { staticClass: "row ml-1" },
              _vm._l(_vm.getDocumentData, function(item, index) {
                return item.title
                  ? _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "col-3 px-1 pl-1 pr-1 mt-1 mb-1 document-default-width"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn wf-product-room-scene-color-item-button",
                            class: {
                              "wf-product-room-scene-color-item-button-active": _vm.isSelected(
                                item
                              ),
                              "wf-product-room-scene-color-item-button-disabled": !item.title
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.updateImage(item)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "img",
                                style: item.icon
                                  ? ""
                                  : "background-color: #ccc;"
                              },
                              [
                                item.icon
                                  ? _c("img", {
                                      staticClass: "document-img",
                                      attrs: { src: item.icon, alt: "img" }
                                    })
                                  : _c("div", { staticClass: "document-img" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "wf-product-room-scene-color-item-name document-title"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "document-item-title" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.title) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              }),
              0
            ),
            _vm._v(" "),
            _vm.showLoadMore
              ? _c("pc-load-more", { attrs: { "load-more": _vm.onLoadMore } })
              : _vm._e(),
            _vm._v(" "),
            _vm.getDocumentData.length == 0 && !_vm.showLoadMore
              ? _c("div", { staticClass: "container" }, [
                  _c("p", {}, [
                    _vm._v(
                      _vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"])
                    )
                  ])
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }